<script setup lang="ts">
import { type IconProps, resolveIcon } from './huge-icon';
import { HugeiconsIcon } from '@hugeicons/vue';

const props = defineProps<IconProps>();
</script>

<template>
  <HugeiconsIcon
    :icon="resolveIcon(props.icon)"
    :size="props.size"
    :class="{ 'animate-spin': props.spin }"
  />
</template>
